import React from 'react';
import SeoHead from '../components/SeoHead';
import Industries from '../components/Industries';

const IndustriesPage = () => {
  return (
    <>
      <SeoHead
        title="Industries we serve"
        description="THINKINGWORLD builds for healthcare, real estate, ecommerce, natural &amp; nutrition, and education — five focus industries where we know the workflows."
        path="/industries"
      />

      <header className="page-header">
        <div className="container">
          <span className="section-eyebrow">Industries</span>
          <h1>We focus where we have shipped real products.</h1>
          <p>
            Five industries we know inside-out — from clinic appointment flows to
            real-estate lead capture to D2C subscription billing.
          </p>
        </div>
      </header>

      <Industries eyebrow="Pick yours" title="Five focus industries." lead="Click into any industry for the specific products and outcomes we ship." />
    </>
  );
};

export default IndustriesPage;
